import script from "./BaseDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDialog.vue?vue&type=script&setup=true&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=13598f9b&scoped=true&lang=css"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13598f9b"]])

export default __exports__